import React, { createContext, useContext, useState, ReactNode } from "react";

export type SettingsTab = "general" | "map" | "activity" | "debug" | "help";

interface SettingsContextType {
  isOpen: boolean;
  currentTab: SettingsTab;
  openSettings: (tab?: SettingsTab) => void;
  closeSettings: () => void;
  setCurrentTab: (tab: SettingsTab) => void;
}

const SettingsContext = createContext<SettingsContextType | null>(null);

interface SettingsProviderProps {
  children: ReactNode;
}

export function SettingsProvider({ children }: SettingsProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState<SettingsTab>("general");

  const openSettings = (tab: SettingsTab = "general") => {
    setCurrentTab(tab);
    setIsOpen(true);
  };

  const closeSettings = () => {
    setIsOpen(false);
  };

  const value: SettingsContextType = {
    isOpen,
    currentTab,
    openSettings,
    closeSettings,
    setCurrentTab,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
}
